import { getWebSocketUrl } from '../utils/websocket'
import useWebSocket, { CONNECTION_STATUS } from './useWebSocket'

const WS_URL = getWebSocketUrl()

/**
 * Custom hook for managing WebSocket connections to channels
 * Replaces 30s polling with real-time messaging (<1s latency)
 * 
 * This is a thin wrapper around useWebSocket for backward compatibility.
 * Maintains the same API as before but uses the consolidated hook internally.
 * 
 * @param {string} channelId - UUID of the channel to connect to
 * @param {function} onMessage - Callback when new message received
 * @param {function} onError - Optional callback for error handling
 * @returns {object} Connection state and utilities
 */
export default function useChannelWebSocket(channelId, onMessage, onError) {
  return useWebSocket({
    wsUrl: WS_URL,
    channelId,
    onMessage,
    onError,
    maxReconnectAttempts: 10,
    autoConnect: true
  })
}

export { CONNECTION_STATUS }
